import { ExpandMoreOutlined } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

interface AccordionProps {
    header: React.ReactNode;
    summary: React.ReactNode;
    isexpanded: boolean;
}

export const CustomAccordion = (props: AccordionProps) => {
    const { header, summary, isexpanded } = props;
    return (
        <Accordion defaultExpanded={isexpanded} sx={{ borderRadius: '10px', boxShadow: 'unset', '&::before': { display: 'none' } }} {...props}>
            <AccordionSummary
                expandIcon={<ExpandMoreOutlined />}
                aria-controls="panel1-content"
                id="panel1-header"
            >
                {header}
            </AccordionSummary>
            <AccordionDetails>
                {summary}
            </AccordionDetails>
        </Accordion>
    );
};
